var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c("div", { staticClass: "row q-mb-sm" }, [
        _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
          _c(
            "div",
            { staticClass: "q-display-1 text-secondary" },
            [
              _c("q-icon", {
                staticClass: "q-mb-sm",
                attrs: { name: "fas fa-chalkboard" }
              }),
              _vm._v(" " + _vm._s(_vm.live_class_title) + "\n            ")
            ],
            1
          )
        ])
      ]),
      _c(
        "q-tabs",
        {
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "live-class",
              label: _vm.$t("live_class")
            },
            slot: "title"
          }),
          _c(
            "q-tab-pane",
            { attrs: { name: "live-class" } },
            [
              _c("live-class", {
                attrs: {
                  platform_type: _vm.platform_type,
                  embed: _vm.embed,
                  title: _vm.live_class_title,
                  description: _vm.live_class_description,
                  room: _vm.live_class_room,
                  status: _vm.status,
                  date_class: _vm.date_class,
                  id_presential: _vm.id_presential,
                  id_event: _vm.id_event,
                  managerTrainings: true
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "row gutter-sm justify-end" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3" },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "tertiary",
                label: _vm.$t("back"),
                icon: "fas fa-chevron-left"
              },
              on: {
                click: function($event) {
                  return _vm.hideModal()
                }
              }
            })
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }